<template>
  <footer class="tw-bg-gray-900 tw-text-white tw-py-12">
    <div class="tw-container tw-mx-auto tw-px-4">
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8">
        <!-- Left Column -->
        <div>
          <div class="tw-mb-4">
            <img
              src="/images/logo-white.png"
              alt="TopEshows logo"
              class="tw-h-16 tw-w-auto tw-object-contain"
              loading="lazy"
            >
          </div>
          <p class="tw-text-gray-400">
            Intelligent B2B matchmaking platform that turns attendees into business relationships. Built for modern B2B event teams.
          </p>
        </div>
        <!-- Middle Column -->
        <div>
          <h4 class="tw-font-semibold tw-mb-4">Quick Links</h4>
          <ul class="tw-space-y-2 tw-text-gray-400">
            <li>
              <RouterLink
                :to="{ name: 'home', hash: '#how-it-works' }"
                class="hover:tw-text-white tw-transition-colors"
              >
                How It Works
              </RouterLink>
            </li>
            <li>
              <RouterLink
                :to="{ name: 'home', hash: '#case-studies' }"
                class="hover:tw-text-white tw-transition-colors"
              >
                Case Studies
              </RouterLink>
            </li>
            <li>
              <RouterLink
                :to="{ name: 'home', hash: '#pricing' }"
                class="hover:tw-text-white tw-transition-colors"
              >
                Pricing
              </RouterLink>
            </li>
          </ul>
          <h4 class="tw-font-semibold tw-mt-6 tw-mb-4">Legal</h4>
          <ul class="tw-space-y-2 tw-text-gray-400">
            <li>
              <RouterLink
                :to="{ name: 'privacy-policy' }"
                class="hover:tw-text-white tw-transition-colors"
              >
                Privacy Policy
              </RouterLink>
            </li>
            <li>
              <RouterLink
                :to="{ name: 'cookie-policy' }"
                class="hover:tw-text-white tw-transition-colors"
              >
                Cookie Policy
              </RouterLink>
            </li>
          </ul>
        </div>
        <!-- Right Column -->
        <div>
          <h4 class="tw-font-semibold tw-mb-4">Contact</h4>
          <p class="tw-text-gray-400 tw-mb-4">
            Ready to transform your event?<br>
            Get in touch with our team.
          </p>
          <a
            :href="appConfig.calendlyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="tw-bg-primary-600 tw-text-white tw-px-6 tw-py-2 tw-rounded-lg hover:tw-bg-primary-700 tw-transition-colors tw-font-semibold tw-inline-block tw-text-center"
          >
            Schedule a Demo
          </a>
        </div>
      </div>
      <div class="tw-border-t tw-border-gray-800 tw-mt-8 tw-pt-8 tw-text-center tw-text-gray-400">
        <p>&copy; {{ new Date().getFullYear() }} TopEshows. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>

